import { useContext, useState } from "react";
import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";

import { POST } from "../../../../providers/useAxiosQuery";
import validateRules from "../../../../providers/validateRules";
import FloatInput from "../../../../providers/FloatInput";
import FloatSelect from "../../../../providers/FloatSelect";
import PageFacultyMonitoringContext from "./PageFacultyMonitoringContext";
import notificationErrors from "../../../../providers/notificationErrors";
import FloatTimePicker from "../../../../providers/FloatTimePicker";
import { checkNetworkStatus } from "../../../../providers/useCapacitorStorage";

export default function ModalFormFacultyLoad() {
	const {
		toggleModalFormFaculty,
		setToggleModalFormFaculty,
		dataDaySchedules,
		dataSchoolYear,
		dataSemester,
		dataFaculty = [],
		dataRooms = [],
		dataBuildings = [],
		dataFloors = [],
	} = useContext(PageFacultyMonitoringContext);

	const [form] = Form.useForm();
	const [dataRoomFilter, setDataRoomFilter] = useState([]);

	const handleFilterRoom = (value, field) => {
		let dataRoomsTemp = [];

		if (field === "building_id") {
			dataRoomsTemp = dataRooms.filter((x) => x.building_id === value);
			form.resetFields(["floor_id", "room_id"]);
		} else if (field === "floor_id") {
			let floor_id = value;
			let building_id = form.getFieldValue("building_id");
			dataRoomsTemp = dataRooms.filter(
				(x) => x.floor_id === floor_id && x.building_id === building_id
			);

			form.resetFields(["room_id"]);
		}

		setDataRoomFilter(dataRoomsTemp);
	};

	const { mutate: mutateFacultyLoad, isLoading: isLoadingFacultyLoad } = POST(
		`api/faculty_load`,
		"faculty_load"
	);

	const onFinish = async (values) => {
		let data = {
			...values,
			time_in: dayjs(values.time_in).format("HH:mm:ss A"),
			time_out: dayjs(values.time_out).format("HH:mm:ss A"),
		};

		checkNetworkStatus().then((res) => {
			if (res.connected) {
				mutateFacultyLoad(data, {
					onSuccess: (res) => {
						if (res.success) {
							notification.success({
								message: "Faculty Load Schedule",
								description: res.message,
							});
							setToggleModalFormFaculty({ open: false, data: null });
						} else {
							notification.error({
								message: "Faculty Load Schedule",
								description: res.message,
							});
						}
					},
					onError: (error) => {
						notificationErrors(error);
					},
				});
			} else {
				notification.error({
					message: "Network Error",
					description: "Please check your network connection.",
				});
			}
		});
	};

	return (
		<Modal
			wrapClassName="modal-wrap-form-faculty-load"
			title={
				toggleModalFormFaculty &&
				toggleModalFormFaculty.data &&
				toggleModalFormFaculty.data.id
					? "Edit Faculty Schedule"
					: "Add Faculty Schedule"
			}
			open={toggleModalFormFaculty.open}
			onCancel={() => {
				setToggleModalFormFaculty({ open: false, data: null });
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					onClick={() => {
						setToggleModalFormFaculty({ open: false, data: null });
					}}
					key={1}
					disabled={isLoadingFacultyLoad}
				>
					CANCEL
				</Button>,
				<Button
					type="primary"
					className="btn-main-primary"
					onClick={() => {
						form.submit();
					}}
					key={2}
					loading={isLoadingFacultyLoad}
				>
					SUBMIT
				</Button>,
			]}
			forceRender
		>
			<Form form={form} onFinish={onFinish}>
				<Form.Item name="profile_id" rules={[validateRules.required]}>
					<FloatSelect label="Faculty No" required options={dataFaculty} />
				</Form.Item>
				<Form.Item name="subject_code" rules={[validateRules.required]}>
					<FloatInput label="Subject Code" required />
				</Form.Item>
				<Form.Item name="section_code" rules={[validateRules.required]}>
					<FloatInput placeholder="Section" label="Section" required />
				</Form.Item>
				<Form.Item name="building_id" rules={[validateRules.required]}>
					<FloatSelect
						label="Building"
						required
						options={dataBuildings.map((item) => {
							return {
								label: item.building,
								value: item.id,
							};
						})}
						onChange={(value) => handleFilterRoom(value, "building_id")}
					/>
				</Form.Item>
				<Form.Item name="floor_id" rules={[validateRules.required]}>
					<FloatSelect
						label="Floor"
						required
						options={dataFloors.map((item) => {
							return {
								label: item.floor,
								value: item.id,
							};
						})}
						onChange={(value) => handleFilterRoom(value, "floor_id")}
					/>
				</Form.Item>
				<Form.Item name="room_id" rules={[validateRules.required]}>
					<FloatSelect
						label="Room No."
						required
						options={dataRoomFilter.map((item) => ({
							value: item.id,
							label: item.room_code,
						}))}
					/>
				</Form.Item>
				<Form.Item name="time_in" rules={[validateRules.required]}>
					<FloatTimePicker label="Time In" required format="hh:mm A" />
				</Form.Item>
				<Form.Item name="time_out" rules={[validateRules.required]}>
					<FloatTimePicker label="Time Out" required format="hh:mm A" />
				</Form.Item>
				<Form.Item name="day_schedule_id" rules={[validateRules.required]}>
					<FloatSelect
						label="Day Schedule"
						required
						options={dataDaySchedules.map((item) => ({
							value: item.id,
							label: item.name,
						}))}
					/>
				</Form.Item>
				<Form.Item name="school_year_id" rules={[validateRules.required]}>
					<FloatSelect
						label="School Year"
						required
						options={dataSchoolYear.map((item) => ({
							value: item.id,
							label: `${item.sy_from}-${item.sy_to}`,
						}))}
					/>
				</Form.Item>
				<Form.Item name="semester_id" rules={[validateRules.required]}>
					<FloatSelect
						label="Semester"
						required
						options={dataSemester.map((item) => ({
							value: item.id,
							label: item.semester,
						}))}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
}
